module.exports = __webpack_public_path__ + "img/chat.ae6edd8c.jpg";